<template>
  <v-container fluid fill-height pa-0>
    <v-layout max row wrap>
      <v-flex md6 offset-md3 xs12>
        <v-card>
          <v-card-text>
            <h2>
              <v-icon>mdi-alert-circle-outline</v-icon>
              Cтраница не найдена
            </h2>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {};
</script>
